"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectIdSchema = void 0;
const joi_1 = __importDefault(require("joi"));
// This accepts both mongodb object (when queried from db) and string (when received from events)
// In any unfortunate case we need to use it, we'll have to refine types
// In order to avoid a dependency to mongo (especially to use this on clien-side)
// let's do some heuristics
exports.ObjectIdSchema = joi_1.default.alternatives(joi_1.default.object({
    getTimestamp: joi_1.default.function().required(),
    toHexString: joi_1.default.function().required(),
    equals: joi_1.default.function().required()
}).allow(null), joi_1.default.string()).meta({ className: 'ObjectId' });
//# sourceMappingURL=mongo.js.map